<template>
  <div class="seal-com" :style="sealStyle">
    <div class="seal-preview-tip" v-if="isPreview">
      <span>预览</span>
    </div>
    <img class="seal-img" v-if="imgUrl" :src="imgUrl" />
    <span v-else-if="sealText" class="area-text" :class="isArea ? '' : 'normal-text'" v-html="sealText"></span>
  </div>
</template>

<script>
import { sealInfoEnum } from '@/constant';
import contractImg from '@/assets/img/signature/公章@2x.png';
import contractAreaImg from '@/assets/img/signature/公章区域@2x.png';
import legalImg from '@/assets/img/signature/法人@2x.png';
import legalAreaImg from '@/assets/img/signature/法人区域@2x.png';
import dayjs from 'dayjs';

export default {
  data() {
    return {};
  },
  props: {
    sealType: {
      type: String,
      validator: val => ['OFFICIAL', 'CONTRACT', 'LEGAL', 'PERSONAL', 'DATE'].includes(val)
    },
    isPreview: {
      type: Boolean,
      default: false
    },
    isArea: {
      type: Boolean,
      default: false
    },
    scale: {
      type: Number,
      default: 1
    },
    imgUrl: {
      type: String,
      default: ''
    },
    personName: {
      type: String,
      default: ''
    },
    dateText: {
      type: String,
      default: ''
    }
  },
  computed: {
    sealText() {
      if (this.isArea) {
        if (this.sealType === 'PERSONAL') {
          return '签署名';
        }
        if (this.sealType === 'DATE') {
          return '日期';
        }
        return '';
      }
      if (this.sealType === 'PERSONAL') {
        return this.personName || '人名';
      }
      if (this.sealType === 'DATE') {
        return this.dateText || dayjs().format('YYYY-MM-DD');
      }
      return '';
    },
    sealStyle() {
      const info = sealInfoEnum[this.sealType] || {};
      const style = {};
      if (info.round) {
        style.borderRadius = '50%';
      }
      style.width = `${Math.round((info.width || 0) * this.scale)}px`;
      style.height = `${Math.round((info.height || 0) * this.scale)}px`;

      if (this.isArea) {
        if (this.sealType === 'CONTRACT' || this.sealType === 'OFFICIAL') {
          style.background = `url(${contractAreaImg})`;
          style.backgroundSize = 'cover';
        } else if (this.sealType === 'LEGAL') {
          style.background = `url(${legalAreaImg})`;
          style.backgroundSize = 'cover';
        } else {
          style.padding = '0 10px';
          style.backgroundColor = `rgba(63, 110, 252, 0.1)`;
          style.border = '1px solid #3f6efc';
        }
      } else {
        if (!this.imgUrl) {
          style.backgroundColor = '#fff';
        }
        if (this.sealType === 'CONTRACT' || this.sealType === 'OFFICIAL') {
          !this.imgUrl && (style.background = `url(${contractImg})`);
          style.backgroundSize = 'cover';
        }
        if (this.sealType === 'LEGAL') {
          !this.imgUrl && (style.background = `url(${legalImg})`);
          style.backgroundSize = 'cover';
        }
        if (this.sealType === 'PERSONAL') {
          style.border = '1px solid #dbdfe9';
        }
        if (this.sealType === 'DATE') {
          style.border = '1px solid #dbdfe9';
        }
      }
      return style;
    }
  }
};
</script>

<style lang="scss" scoped>
.seal-com {
  position: relative;
  box-sizing: border-box;
  width: 0px;
  height: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #3f6efc;

  .seal-preview-tip {
    position: absolute;
    top: -24px;
    left: 0;
    width: 100%;
    height: 20px;
    line-height: 20px;
    text-align: center;
    color: #172237;
    font-size: 14px;
  }

  .seal-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .area-text {
    font-size: 14px;
    white-space: nowrap;

    &.normal-text {
      color: #172237;
    }
  }
}
</style>
